<header
  class="relative w-full top-0 z-40 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4 dark:border-gray-700 dark:bg-gray-900 lg:px-6"
>
  <!-- Left Section -->
  <div class="flex items-center gap-4">
    @if (isSidebarHidden()) {
      <a routerLink="/" class="flex flex-none items-center gap-2 mr-4">
        <div class="flex items-center justify-center rounded-lg">
          <img
            ngSrc="/image/logo2.png"
            alt="Portale Logo"
            width="608"
            height="596"
            style="width: 32px; height: auto"
            priority
          />
        </div>
        <span class="text-sm font-semibold text-gray-900 dark:text-white"
          >Responsabile Della Conservazione</span
        >
      </a>
    }

    @if (isStatusVisible()) {
      <app-status-badge [status]="status()" [showHint]="false" />
    }

    <app-admin-buttons [isAdmin]="isAdmin()" [isStepPage]="isStepPage()" [status]="status()" />
  </div>

  <!-- Right Section -->
  <div class="flex items-center gap-2 lg:gap-4">
    <!-- Home Button -->
    <div class="relative group">
      <a
        routerLink="/"
        class="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
        aria-label="Home"
      >
        <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
      </a>
      <span
        class="pointer-events-none absolute left-1/2 top-full mt-2 -translate-x-1/2 whitespace-nowrap rounded-md border border-gray-200 bg-white px-2 py-1 text-xs font-medium text-gray-700 shadow-sm opacity-0 transition-opacity group-hover:opacity-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200"
        role="tooltip"
        >Home</span
      >
    </div>

    <!-- Communications Button -->
    <div class="relative group">
      <a
        [routerLink]="['/communications']"
        [queryParams]="isStepPage() ? { orgContext: 'true' } : null"
        class="relative flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
        aria-label="Comunicazioni"
        (click)="onCommunicationsClick()"
      >
        <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
          />
        </svg>
        @if (newCommunicationsNr() > 0) {
          <span
            class="absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white"
          >
            {{ newCommunicationsNr() > 99 ? '99+' : newCommunicationsNr() }}
          </span>
        }
      </a>
      <span
        class="pointer-events-none absolute left-1/2 top-full mt-2 -translate-x-1/2 whitespace-nowrap rounded-md border border-gray-200 bg-white px-2 py-1 text-xs font-medium text-gray-700 shadow-sm opacity-0 transition-opacity group-hover:opacity-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200"
        role="tooltip"
        >Comunicazioni e Assistenza</span
      >
    </div>

    <!-- Toggle dark mode -->
    <app-toggle-dark-mode />

    <!-- Profile Dropdown -->
    <app-profile-menu [isAdmin]="isAdmin()" />
  </div>
</header>
